import { render, staticRenderFns } from "./SanofiTreatmentPhase.vue?vue&type=template&id=5648d670&scoped=true&"
import script from "./SanofiTreatmentPhase.vue?vue&type=script&lang=js&"
export * from "./SanofiTreatmentPhase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5648d670",
  null
  
)

export default component.exports